import userApi from '../api/user'

export default {
    storeRechargeChannels(state, channels) {
        state.rechargeChannels = channels;
    },
    controlLoginPopup(state, status) {
        state.showLoginPopup = status;
    },
    controlRegisterPopup(state, status) {
        state.showRegisterPopup = status;
    },
    setLoginPath(state, path) {
        state.loginPath = path;
    },
    getTotalEg(state) {
        let uid = state.user.uid;
        userApi.getEg(uid, (res) => {
            state.totalEg = res.egPoint;
            state.totalRewardEg = res.rewardEgPoint;
        });
    },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js